import React, { useEffect, useState } from 'react';
import Badge from 'react-bootstrap/Badge';

import './style.scss';

const Duration = ({ duration }) => {
    const [durationInWords, setDurationInWords] = useState('');

    const secondsToHms = (d) => {
        d = Number(d);
        let h = Math.floor(d / 3600);
        let m = Math.floor(d % 3600 / 60);
        let s = Math.floor(d % 3600 % 60);

        let hDisplay = h > 0 ? h + ':' : "";
        let mDisplay = m > 0 ? m + ':' : "0:";
        let sDisplay = s > 0 ? (s < 10 ? `0${s}` : s) : '';

        return hDisplay + mDisplay + sDisplay;
    };
    useEffect(() => {
        if (parseFloat(duration) > 0) {
            setDurationInWords(secondsToHms(parseFloat(duration)));
        }
    }, [duration]);

    return duration > 0 ? <Badge bg="secondary" className="duration" style={{ zIndex: '900' }}>
        {durationInWords}
    </Badge>
        : '';
};

export default React.memo(Duration);
